import { render, staticRenderFns } from "./InsightsBuilderPopup.vue?vue&type=template&id=5d6c6f51"
import script from "./InsightsBuilderPopup.vue?vue&type=script&lang=js"
export * from "./InsightsBuilderPopup.vue?vue&type=script&lang=js"
import style0 from "./InsightsBuilderPopup.vue?vue&type=style&index=0&id=5d6c6f51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports